import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.projects.views.FranchiseeProjectDocumentView.';
  public static readonly creationDate = `${Id.prefix}creationDate`;
  public static readonly fileName = `${Id.prefix}fileName`;
  public static readonly status = `${Id.prefix}status`;
  public static readonly authorLabel = `${Id.prefix}authorLabel`;
  public static readonly quoteNumberTitle = `${Id.prefix}quoteNumberTitle`;
  public static readonly purchaseOrderNumberTitle = `${Id.prefix}purchaseOrderNumberTitle`;
  public static readonly generatedDocuments = `${Id.prefix}generatedDocuments`;
  public static readonly deleteDocumentConfirmation = `${Id.prefix}deleteDocumentConfirmation`;
  public static readonly deleteDocumentTitle = `${Id.prefix}deleteDocumentTitle`;
  public static readonly documentDeleted = `${Id.prefix}documentDeleted`;
  public static readonly documentStateAll = `${Id.prefix}documentStateAll`;
  public static readonly documentStatePending = `${Id.prefix}documentStatePending`;
  public static readonly documentStateAvailable = `${Id.prefix}documentStateAvailable`;
  public static readonly documentStateFailed = `${Id.prefix}documentStateFailed`;
  public static readonly documentStateDeleted = `${Id.prefix}documentStateDeleted`;
}

export class LangFranchiseeProjectDocumentView {
  private constructor() {}
  public static creationDate(): string {
    return interpolate(Id.creationDate);
  }
  public static fileName(): string {
    return interpolate(Id.fileName);
  }
  public static status(): string {
    return interpolate(Id.status);
  }
  public static authorLabel(params: { author: string }): string {
    return interpolate(Id.authorLabel, params);
  }
  public static quoteNumberTitle(params: { quoteNumber: string; quoteTitle: string; authorLabel: string }): string {
    return interpolate(Id.quoteNumberTitle, params);
  }
  public static purchaseOrderNumberTitle(params: {
    purchaseOrderNumber: string;
    purchaseOrderTitle: string;
    authorLabel: string;
  }): string {
    return interpolate(Id.purchaseOrderNumberTitle, params);
  }
  public static generatedDocuments(): string {
    return interpolate(Id.generatedDocuments);
  }
  public static deleteDocumentConfirmation(): string {
    return interpolate(Id.deleteDocumentConfirmation);
  }
  public static deleteDocumentTitle(): string {
    return interpolate(Id.deleteDocumentTitle);
  }
  public static documentDeleted(): string {
    return interpolate(Id.documentDeleted);
  }
  public static readonly documentState = {
    all: () => interpolate(Id.documentStateAll),
    pending: () => interpolate(Id.documentStatePending),
    available: () => interpolate(Id.documentStateAvailable),
    failed: () => interpolate(Id.documentStateFailed),
    deleted: () => interpolate(Id.documentStateDeleted)
  };
}

export class FranchiseeProjectDocumentViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.creationDate, 'Creation Date', 'Column title for document creation date');
    register.add(Id.fileName, 'File Name', 'Column title for document file name');
    register.add(Id.status, 'Status', 'Column title for document status');
    register.add(Id.authorLabel, " ({{glossary 'author'}}: {{author}})", 'Label for author in resource links');
    register.add(Id.quoteNumberTitle, '{{quoteNumber}} - {{quoteTitle}}{{authorLabel}}', 'Quote resource link display');
    register.add(
      Id.purchaseOrderNumberTitle,
      '{{purchaseOrderNumber}} - {{purchaseOrderTitle}}{{authorLabel}}',
      'Purchase order resource link display'
    );
    register.add(
      Id.generatedDocuments,
      "Generated {{glossary 'document:plural'}}",
      'Section header for generated documents'
    );
    register.add(
      Id.deleteDocumentConfirmation,
      "Are you sure you want to delete the {{glossary 'document'}}?",
      'Confirmation message for deleting a document'
    );
    register.add(Id.deleteDocumentTitle, "Delete {{glossary 'document'}}?", 'Title for delete document confirmation');
    register.add(Id.documentDeleted, "{{glossary 'document'}} deleted", 'Toast message for document deleted');
    register.add(Id.documentStateAll, 'All', 'Document state: All');
    register.add(Id.documentStatePending, 'Pending', 'Document state: Pending');
    register.add(Id.documentStateAvailable, 'Available', 'Document state: Available');
    register.add(Id.documentStateFailed, 'Failed', 'Document state: Failed');
    register.add(Id.documentStateDeleted, 'Deleted', 'Document state: Deleted');
  }
}
